<template>
    <div class="skeleton-wrapper">
        <div class="thumbnail-skeleton-gs gs-skeleton-animation"></div>

        <div class="content">
            <div class="breadcrumbs-skeleton-gs gs-skeleton-animation"></div>

            <div class="scene-row-gs">
                <div class="scene-name-skeleton-gs gs-skeleton-animation"></div>
                <div class="mini-thumbnail-gs gs-skeleton-animation"></div>
                <div class="scene-name-skeleton-gs gs-skeleton-animation"></div>
            </div>
        </div>
    </div>
</template>
